export var AuthorizeErrorCodes;
(function (AuthorizeErrorCodes) {
    // Login Org does not exist for user
    AuthorizeErrorCodes["UserLoginOrgNotFound"] = "authorize.UserLoginOrgNotFound";
    AuthorizeErrorCodes["AuthorizeSharedLambdaTimedOut"] = "authorize.AuthorizeSharedLambdaTimedOut";
    AuthorizeErrorCodes["AuthorizeSharedLambdaFailed"] = "authorize.AuthorizeSharedLambdaFailed";
    AuthorizeErrorCodes["AuthorizeDirectTempUserNotFound"] = "authorize.AuthorizeDirectTempUserNotFound";
})(AuthorizeErrorCodes || (AuthorizeErrorCodes = {}));
//# sourceMappingURL=authorizeErrorCodes.js.map